
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import Toasted from 'vue-toasted';
import { formatDateTime, formatDurationSeconds, formatTime } from "../../../util";
import { Card, TimeTracker } from "../../backend/backendapi";
import { KanbanState } from "../kanban.model";
import { getCardById, getDurationSecondsSum } from "./util";
import CenterOnParent from "../../util/CenterOnParent";

Vue.use(Toasted, { duration: 2000 });

@Component({
  name: 'RunningTimeTracking',
  components: { CenterOnParent },
})
export default class RunningTimeTracking extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;
  @Prop({ required: true })
  readonly tracker!: TimeTracker;

  comment: string = '';
  tickerId: any;
  ticker: number = 0;
  updateCommentTimeout: any;

  //getter
  get currentDurationSeconds(): number {
    this.ticker; // computed property recompute trigger
    if (!this.tracker)
      return 0;
    return (Date.now() - this.tracker.startTime.getTime()) / 1000;
  }

  get currentDurationString(): string {
    if (!this.tracker)
      return '';
    return formatDurationSeconds(this.currentDurationSeconds);
  }

  get totalDurationString(): string {
    return this.card ? formatDurationSeconds(getDurationSecondsSum(this.card) + this.currentDurationSeconds) : '';
  }

  get startTime(): string {
    if (Date.now() - this.tracker.startTime.getTime() < 24 * 60 * 60 * 1000) {
      return formatTime(this.tracker.startTime);
    } else {
      return formatDateTime(this.tracker.startTime);
    }
  }

  get card(): Card | null {
    return getCardById(this.state, this.tracker.cardId);
  }

  //life cycle
  created(): void {
    this.comment = this.tracker.comment ?? '';
  }
  
  mounted(): void {
    this.tickerId = setInterval(() => this.ticker++, 499);
  }

  unmounted(): void {
    clearInterval(this.tickerId);
  }

  //functions
  async stop(): Promise<void> {
    this.$emit('stop', this.comment);
  }

  //watches
  @Watch('comment')
  async updateComment(newVal: string): Promise<void> {
    clearTimeout(this.updateCommentTimeout);
    this.updateCommentTimeout = setTimeout(() => {
      if (newVal !== this.tracker.comment) {
        this.$emit('updateComment', this.comment);
      }
    }, 500);
  }
}
